import React, { useRef } from "react";

import * as S from "./styles";

export const Slide9: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <S.Container>
      <S.Credit>
        Parka, R$ 3.690, e saia, R$ 1.680, ambos À La Garçonne.
      </S.Credit>
      <S.Video>
        <video ref={videoRef} muted autoPlay loop playsInline>
          <source
            src="https://player.vimeo.com/external/538845279.hd.mp4?s=e61c5259b3dc00d457f58184a0758f7f0c08541c&profile_id=175&download=1"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
